module.exports = __webpack_public_path__ + "static/media/file.6f332670.svg";